
<script setup lang="ts">
import type { Praeparat } from '@/types/otc/praeparat';
import { useSearchResultItem } from '../composables/useSearchResultItem';
import OverviewImage from "@/vue_components/product-overview/overview-image/overview-image.vue";

/**
 * Einzelnes Produkt-Item in der Suchergebnis-Liste
 * Zeigt Produktbild, Beschreibung und Aktionsbuttons
 */

const props = defineProps<{
  product: Praeparat;
  searchterm: string;
}>();

const emit = defineEmits<{
  (e: 'readmore', product: typeof props.product, searchterm: string): void;
  (e: 'order', pzns: string[]): void;
  (e: 'pflichttext', produktId: number, praeparatId: number, searchterm: string): void;
}>();

const {
  labelReadMore,
  labelOrder,
  labelPflichttext,
  hasArticles,
  shortDescription,
  onReadMore,
  onOrder,
  onPflichttext
} = useSearchResultItem(props, emit);
</script>

<template>
  <div class="search-result-item" :id="product.id.toString()">  
    <div class="imglink-product-item" @click.prevent="onReadMore">
      <div class="image-wrap">
        <OverviewImage :praeparat="product" />
      </div>
    </div>

    <div class="product-description">
      <h3 class="product-title">{{ product.name }}</h3>
      <p v-if="shortDescription" class="product-subtitle">
        {{ shortDescription }}
      </p>
    </div>

    <div class="product-footer">
      <a href="#" class="btn-readmore"
         @click.prevent="onReadMore"
         :title="`Mehr über ${product.name} erfahren`"
      >
        {{ labelReadMore }}
      </a>

      <!--<a href="#" v-if="hasArticles"
         target="_blank" 
         :data-sku="`${onOrder}`" 
         class="btn btn-readmore btn-order"
         :title="`${product.name} in der Apotheke bestellen`"
         @click.prevent.default>
        {{ labelOrder }}
      </a>-->

      <div v-if="product.pflichttext" class="pflichttext">
        <a @click.prevent="onPflichttext"
           :title="`Pflichttext für ${product.name} anzeigen`">
          {{ labelPflichttext }}
        </a>
      </div>
    </div>
  </div>
</template>

<style scoped>
</style>